import React from "react";
import { Link } from "react-router-dom";

import styles from "./Button.module.scss";

const Button = ({
  type = "button",
  name = "button",
  text,
  href,
  onClick,
  isWide = true,
  classes,
  addStyle,
  isSuccess = false,
  ...otherProps
}) => {
  const classNames = [
    styles.button,
    isWide ? [styles["addStyle"]] : null,
    ...(classes && classes.includes("white") ? [styles["white"]] : []),
  ].join(" ");

  if (href) {
    return (
      <Link
        to={href}
        className={classNames}
        type={type}
        name={name}
        aria-label={name}
        onClick={onClick}
        {...otherProps}>
        {text}
      </Link>
    );
  }

  return (
    <button
      style={isSuccess ? { backgroundColor: "#5bbf5bc7", border: "1px solid #fff" } : {}}
      className={classNames}
      type={type}
      name={name}
      aria-label={name}
      onClick={onClick}
      {...otherProps}>
      {text}
    </button>
  );
};

export default Button;
